import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Button,
  makeStyles,
  Grid,
} from "@material-ui/core";
import { NotInterested } from "@material-ui/icons";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { TextField } from "@ofqual/portal-components/components/TextField";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { EventNotification } from "../../domain/EventNotification";
import { closeItem } from "../../redux/actions";
import { Error } from "../common/Error";

const useStyles = makeStyles((theme) => ({
  dialogActions: {
    padding: 15,
  },
  body: {
    marginTop: 5,
    marginBottom: 5,
  },
}));

export const CloseButtonAndDialog: React.FC<{
  eventNotification: EventNotification;
}> = ({ eventNotification }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <AppBarButton
        Icon={NotInterested}
        text="Close"
        tooltip="Close event notification"
        onClick={() => setIsOpen(true)}
        data-test="close-notification-button"
      />
      {isOpen && eventNotification && (
        <CloseDialog
          eventNotification={eventNotification}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

type CloseDialogProps = {
  eventNotification: EventNotification;
  onClose: () => void;
};

const CloseDialog: React.FC<CloseDialogProps> = ({
  onClose,
  eventNotification,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { handleSubmit, control, errors } = useForm();

  const handleCloseItem = (data: { reason: string }) => {
    dispatch(closeItem(eventNotification.id, data.reason));
    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="close-en-dialog"
    >
      <DialogTitle data-test="close-en-dialog-title">
        Closure confirmation
        <Divider />
      </DialogTitle>

      <DialogContent>
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="reason"
                defaultValue={null}
                rules={{ required: true, maxLength: 5000 }}
                as={
                  <TextField
                    label="Reason for closure"
                    data-test="closure-reason"
                    required
                    multiline
                    rows={5}
                  />
                }
              />
              {errors.reason && errors.reason.type === "required" && (
                <Error>This field is required</Error>
              )}
              {errors.reason && errors.reason.type === "maxLength" && (
                <Error>Reason must be less than 5000 characters</Error>
              )}
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={onClose}
          color="primary"
          data-test="close-close-button"
        >
          Close
        </Button>
        <Button
          onClick={handleSubmit(handleCloseItem)}
          color="primary"
          data-test="confirm-close-button"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
